<template>
  <div class="column">
    <p v-if="label" class="refine-search-multi-checkbox-button__label text-weight-bolder primary-text">{{ label }}</p>
    <div class="row q-col-gutter-sm">
      <div v-for="(option, index) in options" :key="index" :class="optionColClass">
        <CheckboxButton
          v-model="computedSelected[getOptionKey(option)]"
          :label="option.label"
          :value="computedSelected[getOptionKey(option)]"
          fullWidth
          :disabled="disabled"
          @input="handleInput(option, $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CheckboxButton from '../CheckboxButton';

export default {
  name: 'RefineSearchGroupedCheckboxButton',
  props: {
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true,
      validator: (value) => Array.isArray(value) && value.every((opt) => 'id' in opt && 'label' in opt)
    },
    value: {
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fullWidthOnMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedOptions: { ...this.value },
      isSyncingFromProp: false
    };
  },
  computed: {
    optionColClass() {
      return this.fullWidthOnMobile ? 'col-12 col-sm-6' : 'col-6';
    },
    computedSelected() {
      // Create a computed object that maps option keys to their checked state
      const computed = {};
      this.options.forEach((option) => {
        const key = this.getOptionKey(option);
        if (Array.isArray(option.value)) {
          // If option.value is an array, check if ANY value in the array is selected
          // Check each value in the array against selectedOptions
          const isSelected = option.value.some((val) => {
            return this.selectedOptions[val] === true;
          });
          computed[key] = isSelected;
        } else {
          // If option.value is a string, use it directly
          computed[key] = this.selectedOptions[option.value] === true;
        }
      });
      return computed;
    }
  },
  watch: {
    value: {
      handler(newValue) {
        // Prevent circular updates - only sync if different
        if (!this.isSyncingFromProp) {
          this.isSyncingFromProp = true;
          // Deep clone to ensure reactivity
          this.selectedOptions = JSON.parse(JSON.stringify(newValue || {}));
          this.$nextTick(() => {
            this.isSyncingFromProp = false;
          });
        }
      },
      deep: true
    }
  },
  methods: {
    getOptionKey(option) {
      // Generate a unique key for the option (use first value if array, or value itself)
      if (Array.isArray(option.value)) {
        return option.value[0];
      }
      return option.value;
    },
    handleInput(option, checked) {
      // Only emit if change came from user interaction, not prop sync
      if (!this.isSyncingFromProp) {
        if (Array.isArray(option.value)) {
          // If option.value is an array, set ALL values in the array to the same state
          option.value.forEach((val) => {
            this.$set(this.selectedOptions, val, checked);
          });
        } else {
          // If option.value is a string, set it directly
          this.$set(this.selectedOptions, option.value, checked);
        }
        // Emit the updated selectedOptions
        this.$emit('input', { ...this.selectedOptions });
      }
    }
  },
  components: { CheckboxButton }
};
</script>

<style lang="sass" scoped>
@import '../../../styles/calculator/vehicle-result-page-breakpoints'
@import '../../../styles/calculator/refine-embedded'

@media (max-width: $vr-phone-toolbar-max)
  .refine-search-multi-checkbox-button__label
    +refine-embedded-section-label-bold
</style>
